module.exports = __webpack_public_path__ + "img/call-icon.5304a430.svg";